import type { ReactNode } from "react";
import { Card } from "@/components/ui";
import type { FirmReferralDirectoryEntry } from "@/lib/data/requests/firms/referral-profile";
import {
  ReferralContactDetails,
  ReferralFirmIdentity,
  ReferralPracticeAreas,
  ReferralServiceStates,
} from "./ReferralFirmCells";

export function ReferralFirmCard({
  firm,
  footer,
}: {
  firm: FirmReferralDirectoryEntry;
  footer?: ReactNode;
}) {
  return (
    <Card className="flex min-w-0 flex-col overflow-hidden">
      <div className="bg-muted/30 border-b p-4">
        <ReferralFirmIdentity name={firm.name} />
      </div>
      <div className="flex flex-1 flex-col gap-4 p-4 text-sm">
        <div className="space-y-2">
          <p className="text-muted-foreground text-xs font-medium">
            Practice areas
          </p>
          <ReferralPracticeAreas areas={firm.practiceAreas} />
        </div>
        <div className="space-y-2">
          <p className="text-muted-foreground text-xs font-medium">
            Service states
          </p>
          <ReferralServiceStates states={firm.serviceAreas} />
        </div>
        <div className="mt-auto border-t pt-3">
          <ReferralContactDetails firm={firm} />
        </div>
      </div>
      {footer && (
        <div className="bg-muted/20 flex flex-wrap items-center justify-between gap-3 border-t px-4 py-3">
          {footer}
        </div>
      )}
    </Card>
  );
}
